import "../App.css";
import { useTranslation } from "react-i18next";
import useThemeColor from "../hooks/TopBarColorWheel";
import useContainerHeight from "../hooks/useContainerHeight";

export function PaymentErrorPage() {
  const { t } = useTranslation();
  useThemeColor();
  const containerHeight = useContainerHeight();
  return (
    <div className="App" style={{ height: containerHeight - 48 }}>
      <div
        className="App-header"
        style={{ justifyContent: "center", textAlign: "center" }}
      >
        <p className="text-h1">{t("payment.status.error")}</p>
        <p className="text-h1 top-margin-m">
          {t("payment.status.tryAgainLater")}
        </p>
      </div>

      <div className="background"></div>
    </div>
  );
}
